import React, { useState, useEffect } from "react";
import classes from "./login.module.css";
import Input from "./Input";
import Button from "./button";
import Link from "./link";
import axios from "../../Axios";
import { useHistory } from "react-router-dom";
import { notification } from "antd";

const intialState = {
  password: null,
};

const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};
const SetPassword = (props) => {
  const history = useHistory();
  const [state, setState] = useState({ ...intialState });
  const [loading, setLoading] = useState(false);
  const [isValid, setValid] = useState(false);
  const { password } = state;

  useEffect(() => {
    if(password===null)
      setValid(false)
    else
      setValid(true)
  }, [state, password])
  const clickHandler = (e) => {
    setLoading(true);
    e.preventDefault();
    const jwtToken=history.location.search.split("=")[1];
    const data={jwtToken,password}
    axios
      .post("/admin/reset", data)
      .then((res) => {
        setLoading(false);
          if(res.data.success)
          {
              openNotificationWithIcon(
                "success",
                "New Password has been set ",
                `Login To Continue`
                );
                history.push('/')

          }
          else 
          {
            openNotificationWithIcon("error", "Something went wrong", `${res.data.errors}`);

          }
      })
      .catch((err) => {
        setLoading(false);
        
        openNotificationWithIcon("error", "Something went wrong", `${err}`);
      });
  };

  const changeHandler = (e) => {
    let { name, value } = e.target;
    if(value.trim()==='')
      value = null

    setState(() => ({ ...state, [name]: value }));
  };
  return (
    <>
      <h1 className={classes.login}>new Password</h1>
      <span className={classes.text}>Please enter new password.</span>

      <Input
        onChange={changeHandler}
        name="password"
        value={password?password:''}
        type="password"
        err={null}
        HolderClass={classes.input}
        placeholder="new-password"
      />

      <Link href="/login" extraClass={classes.link}>
        Login To Your Account
      </Link>

      <Button onClick={clickHandler} extraClass={classes.button} isLoading={loading} disabled={!isValid}>
        Continue
      </Button>
    </>
  );
};

export default SetPassword;

